import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      component: () => import('@/components/home/home'),
      name: 'home',
      redirect: '/indexs',
      children: [
        { 
          path: '/headers',
          component: () => import('@/components/headers/headers'),
        }, 
        {
          path: '/banners',
          component: () => import('@/components/banner/banner'),
        }, {
          path: '/journal',
          component: () => import('@/components/bexam/journal'),
          name: 'journal'
        },
        {
          path: '/zlSingle',
          component: () => import('@/components/Journal/zlSingle'),
          name: 'zlSingle'
        },
        {
          path: '/qkSingle',
          component: () => import('@/components/Journal/qkSingle'),
          name: 'qkSingle'
        },
        {
          path: '/raceDetail',
          component: () => import('@/components/race/raceDetail')
        },
        {
          path: '/raceList',
          component: () => import('@/components/race/raceList')
        },
        {
          path: '/indexs',
          component: () => import('@/components/index/index'),
          name: 'indexs',
          meta: {
            title: '中国建筑工业出版社-建筑设计专业知识服务',
            keepAlive: true
          },
          children: [
            {
              path: '/builddata',
              component: () => import('@/components/builddata/builddata'),
              name: 'builddata',
              redirect: '/datum',
              children: [
                {
                  path: '/datum',
                  component: () => import('@/components/datum/datum'),
                  name: 'datum'
                }, {
                  path: '/book',
                  component: () => import('@/components/book/book'),
                  name: 'book'
                }, {
                  path: '/qikan',
                  component: () => import('@/components/qikan/qikan'),
                  name: 'qikan'
                }, {
                  path: '/standard',
                  component: () => import('@/components/standard/standard'),
                  name: 'standard'
                }, {
                  path: '/cas',
                  component: () => import('@/components/case/case'),
                  name: 'cas'
                }, {
                  path: '/dataset',
                  component: () => import('@/components/dataset/dataset'),
                  name: 'dataset'
                }
              ]
            }, {
              path: '/inbexam',
              component: () => import('@/components/inbexam/inbexam'),
              name: 'inbexam',
              children: [
                {
                  path: '/infirst',
                  component: () => import('@/components/inbexam/infirst'),
                  name: 'infirst'
                }
              ]
            }, {
              path: '/bimskill',
              component: () => import('@/components/bimskill/bimskill'),
              name: 'bimskill'
            }, {
              path: '/gardencon',
              component: () => import('@/components/gardencon/gardencon'),
              name: 'gardencon'
            }, {
              path: '/roomcon',
              component: () => import('@/components/roomcon/roomcon'),
              name: 'roomcon'
            }, {
              path: '/devicecon',
              component: () => import('@/components/devicecon/devicecon'),
              name: 'devicecon'
            }
          ]
        }, {
          path: '/tradition',
          component: () => import('@/components/tradition/tradition'),
          name: 'tradition',
          meta: { title: '中国传统建筑营造技艺与文化' }
        }, {
          path: '/design',
          component: () => import('@/components/design/design'),
          name: 'design',
          meta: { title: '建筑设计资料集' },
          children: [
            {
              path: '/book',
              component: () => import('@/components/book/book'),
              name: 'book'
            }, {
              path: '/qikan',
              component: () => import('@/components/qikan/qikan'),
              name: 'qikan'
            }, {
              path: '/standard',
              component: () => import('@/components/standard/standard'),
              name: 'standard'
            }, {
              path: '/cas',
              component: () => import('@/components/case/case'),
              name: 'cas'
            }, {
              path: '/dataset',
              component: () => import('@/components/dataset/dataset'),
              name: 'dataset'
            }
          ]
        }, {
          path: '/designCon',
          component: () => import('@/components/design/designCon/designCon'),
          name: 'designCon',
          redirect: '/designZlj',
          children:[
            {
              path: '/designZlj',
              component: () => import('@/components/design/designZlj/designZlj'),
              name: 'designZlj'
            },{
             path: '/designCgf',
             component: () => import('@/components/design/designCgf/designCgf'),
             name: 'designCgf'
           },{
              path: '/designZsfw',
              component: () => import('@/components/design/designZsfw/designZsfw'),
              name: 'designZsfw'
            }
          ]
        }, {
          path: '/designAl',
          component: () => import('@/components/design/designAl/designAl'),
          name: 'designAl',
        }, {
          path: '/bexam',
          component: () => import('@/components/bexam/bexam'),
          name: 'bexam',
          meta: { title: '建筑师' }
        }, {
          path: '/bexamfirst',
          component: () => import('@/components/bexamfirst/bexamfirst'),
          name: 'bexamfirst'
        }, {
          path: '/bexamsecond',
          component: () => import('@/components/bexamsecond/bexamsecond'),
          name: 'bexamsecond'
        }, {
          path: '/bim',
          component: () => import('@/components/bim/bim'),
          name: 'bim',
          meta: { title: 'BIM技术' },
          children: [
            {
              path: '/bimBook',
              component: () => import('@/components/bimBook/bimBook'),
              name: 'bimBook'
            }, {
              path: '/kejian',
              component: () => import('@/components/kejian/kejian'),
              name: 'kejian'
            }, {
              path: '/comlib',
              component: () => import('@/components/comlib/comlib'),
              name: 'comlib'
            }, {
              path: '/modellib',
              component: () => import('@/components/modellib/modellib'),
              name: 'modellib'
            }, {
              path: '/bimclass',
              component: () => import('@/components/bimclass/bimclass'),
              name: 'bimclass'
            }, {
              path: '/bimask',
              component: () => import('@/components/bimask/bimask'),
              name: 'bimask'
            }
          ]
        }, {
          path: '/garden',
          component: () => import('@/components/garden/garden'),
          name: 'garden',
          meta: { title: '园林景观' },
          children: [
            {
              path: '/gardencase',
              component: () => import('@/components/gardencase/gardencase'),
              name: 'gardencase'
            }, {
              path: '/gardenclass',
              component: () => import('@/components/gardenclass/gardenclass'),
              name: 'gardenclass'
            }, {
              path: '/gardenbook',
              component: () => import('@/components/gardenbook/gardenbook'),
              name: 'gardenbook'
            }, {
              path: '/gardenqk',
              component: () => import('@/components/gardenqk/gardenqk'),
              name: 'gardenqk'
            }, {
              path: '/gardenbz',
              component: () => import('@/components/gardenbz/gardenbz'),
              name: 'gardenbz'
            }, {
              path: '/gardendata',
              component: () => import('@/components/gardendata/gardendata'),
              name: 'gardendata'
            }
          ]
        }, {
          path: '/interiordesign',
          component: () => import('@/components/room/room'),
          name: 'interiordesign',
          meta: { title: '室内设计' },
          children: [
            {
              path: '/roomvideo',
              component: () => import('@/components/roomvideo/roomvideo'),
              name: 'roomvideo'
            }, {
              path: '/roomdata',
              component: () => import('@/components/roomdata/roomdata'),
              name: 'roomdata'
            }, {
              path: '/roomocen',
              component: () => import('@/components/roomocen/roomocen'),
              name: 'roomocen'
            }, {
              path: '/roomqikan',
              component: () => import('@/components/roomqikan/roomqikan'),
              name: 'roomqikan'
            }
          ]
        }, {
          path: '/build',
          component: () => import('@/components/build/build'),
          name: 'build',
          meta: { title: '建筑设备' }
        }, {
          path: '/secondEffieicient',
          component: () => import('@/components/efficient/secondEfficient/secondEfficient'),
          name: 'secondEffieicient',
          meta: { title: '建筑节能' }
        }, {
          path: '/footers',
          component: () => import('@/components/footers/footers')
        }
      ]
    }, 
    {
      path: '/bimaskmore',
      component: () => import('@/components/bimask/bimaskmore'),
      name: 'bimaskmore'
    }, {
      path: '/asking',
      component: () => import('@/components/asking/asking'),
      name: 'asking'
    }, {
      path: '/askdetail',
      component: () => import('@/components/asking/askdetail'),
      name: 'askdetail'
    }, {
      path: '/askprice',
      component: () => import('@/components/asking/askprice'),
      name: 'askprice'
    }, {
      path: '/askanswer',
      component: () => import('@/components/asking/askanswer'),
      name: 'askanswer'
    }, {
      path: '/payfinish',
      component: () => import('@/components/payfinish/payfinish'),
      name: 'payfinish',
      meta: { title: '支付完成', requireAuth: true }
    }, {
      path: '/match',
      component: () => import('@/components/bexam/match/match'),
      name: 'match'
    },{
      path: '/contact',
      component: () => import('@/components/bexam/match/contact'),
      name: 'contact'
    }, {
      path: '/login',
      component: () => import('@/components/login/login'),
      name: 'Login',
      meta: {
        title: '欢迎登录',
        requireAuth: true
      }
    },
    {
      path: '/register',
      component: () => import('@/components/register/register'),
      name: 'Register',
      meta: {
        title: '欢迎注册',
        requireAuth: true
      }
    },
    {
      path: '/gwc',
      component: () => import('@/components/gwc/gwc'),
      name: 'gwc',
      meta: {
        title: '我的购物车',
        requireAuth: true,
        jumpAuth: true
      }
    },
    {
      path: '/personal',
      component: () => import('@/components/personal/personal'),
      name: 'personal',
      redirect: '/personalHome',
      meta: {
        title: '个人中心',
        requireAuth: true,
        jumpAuth: true
      },
      children: [
        {
          path: '/personalHome',
          component: () => import('@/components/personal/personalHome'),
          name: 'personalHome',
          meta: {
            title: '个人中心',
            requireAuth: true,
            jumpAuth: true
          }
        },
        {
          path: '/personalInfo',
          component: () => import('@/components/personal/personalInfo'),
          name: 'personalInfo',
          meta: {
            title: '个人中心',
            requireAuth: true,
            jumpAuth: true
          }
        },
        {
          path: '/personalSafe',
          component: () => import('@/components/personal/personalSafe'),
          name: 'personalSafe',
          meta: {
            title: '个人中心',
            requireAuth: true,
            jumpAuth: true
          }
        },
        {
          path: '/address',
          component: () => import('@/components/personal/personalAddress'),
          name: 'address',
          meta: {
            title: '个人中心',
            requireAuth: true,
            jumpAuth: true
          }
        },
        {
          path: '/personalmsg',
          component: () => import('@/components/personal/personalmsg'),
          name: 'personalmsg',
          meta: {
            title: '个人中心',
            requireAuth: true,
            jumpAuth: true
          }
        },
        {
          path: '/msgdetail',
          component: () => import('@/components/personal/msgdetail'),
          name: 'msgdetail',
          meta: {
            title: '个人中心',
            requireAuth: true,
            jumpAuth: true
          }
        },
        {
          path: '/myfootprint',
          component: () => import('@/components/personal/myfootprint'),
          name: 'myfootprint',
          meta: {
            title: '个人中心',
            requireAuth: true,
            jumpAuth: true
          }
        },
        {
          path: '/personalOrder',
          component: () => import('@/components/personal/personalOrder'),
          name: 'personalOrder',
          meta: {
            title: '个人中心',
            requireAuth: true,
            jumpAuth: true
          }
        },
        {
          path: '/purchased',
          component: () => import('@/components/personal/purchased'),
          name: 'purchased',
          meta: {
            title: '个人中心',
            requireAuth: true,
            jumpAuth: true
          }
        },
        {
          path: '/exchange',
          component: () => import('@/components/personal/exchange'),
          name: 'exchange',
          meta: {
            title: '个人中心',
            requireAuth: true,
            jumpAuth: true
          }
        },
        {
          path: '/personalask',
          component: () => import('@/components/personal/personalask'),
          name: 'personalask',
          meta: {
            title: '个人中心',
            requireAuth: true,
            jumpAuth: true
          }
        },
        {
          path: '/personalanswer',
          component: () => import('@/components/personal/personalanswer'),
          name: 'personalanswer',
          meta: {
            title: '个人中心',
            requireAuth: true,
            jumpAuth: true
          }
        },
        {
          path: '/personalcollect',
          component: () => import('@/components/personal/personalcollect'),
          name: 'personalcollect',
          meta: {
            title: '个人中心',
            requireAuth: true,
            jumpAuth: true
          }
        },
        {
          path: '/mechanism',
          component: () => import('@/components/personal/mechanism'),
          name: 'mechanism',
          meta: {
            title: '个人中心',
            requireAuth: true,
            jumpAuth: true
          }
        }
      ]
    },
    {
      path: '/activity',
      component: () => import('@/components/activity/activity'),
      name: 'activity'
    },
    {
      path: '/search',
      component: () => import('@/components/search/search'),
      name: 'search'
    },
    {
      path: '/route',
      component: () => import('@/components/route/route'),
      name: 'route'
    },
    {
      path: '/askcasedetail',
      component: () => import('@/components/asking/askcase/askcasedetail'),
      name: 'askcasedetail'
    }, {
      path: '/pay',
      component: () => import('@/components/pay/pay'),
      name: 'pay',
      meta: {
        title: '确认支付',
        // requireAuth: true
      }
    }, {
      path: '/vip',
      component: () => import('@/components/vip/vip'),
      name: 'vip',
      meta: {
        title: 'VIP',
        requireAuth: true
      }
    },
    {
      path: '/account',
      component: () => import('@/components/account/account'),
      name: 'account',
      meta: {
        title: '确认订单',
        // requireAuth: true
      }
    }, {
      path: '/alipay',
      component: () => import('@/components/onlineApply/alipay'),
      name: 'alipay',
      meta: {
        title: '支付确认'
      }
    }
  ],
  
// scrollBehavior (to, from, savedPosition) {
//   if (to.hash) {
//     return {
//       selector: to.hash
//     }
//   }
// }
})



// WEBPACK FOOTER //
// ./src/router/index.js